import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { ButtonComponent, ButtonType } from '../../../../shared/components/button/button.component';
import { ActiveBroadcast } from '../../types/broadcast';

@Component({
    selector: 'juyo-broadcast-item',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrl: './broadcast-item.scss',
    imports: [ButtonComponent],
    template: `
        <div class="broadcast-body">
            @if (broadcast().title) {
                <p class="broadcast-title">{{ broadcast().title }}</p>
            }
            @if (broadcast().html) {
                <div class="broadcast-text broadcast-html" [innerHTML]="broadcast().html"></div>
            } @else if (broadcast().text) {
                <p class="broadcast-text">{{ broadcast().text }}</p>
            }
            @if (broadcast().imageUrl) {
                <img class="broadcast-image" [src]="broadcast().imageUrl" [alt]="broadcast().title || 'Message'" />
            }
        </div>
        <div class="buttons">
            @if (!isPreview()) {
                <juyo-button
                    [buttonType]="ButtonType.TRANSPARENT"
                    [widthInPx]="buttonWidth()"
                    [heightInPx]="30"
                    (clicked)="dontShowAgain.emit()"
                >
                    Don't show me again
                </juyo-button>
            }
            <juyo-button
                [buttonType]="hasCta() ? ButtonType.TRANSPARENT : ButtonType.PURPLE"
                [widthInPx]="buttonWidth()"
                [heightInPx]="30"
                (clicked)="closed.emit()"
            >
                Close
            </juyo-button>
            @if (hasCta()) {
                <juyo-button
                    [buttonType]="ButtonType.PURPLE"
                    [widthInPx]="buttonWidth()"
                    [heightInPx]="30"
                    (clicked)="onCtaClick()"
                >
                    {{ broadcast().buttonLabel }}
                </juyo-button>
            }
        </div>
    `,
})
export class BroadcastItemComponent {
    protected readonly ButtonType = ButtonType;

    public broadcast = input.required<ActiveBroadcast>();
    public isPreview = input<boolean>(false);

    public dontShowAgain = output<void>();
    public closed = output<void>();

    protected hasCta = computed(() => !!this.broadcast().buttonLabel && !!this.broadcast().buttonUrl);
    protected buttonWidth = computed(() => (this.hasCta() && !this.isPreview() ? 170 : 200));

    protected onCtaClick(): void {
        window.open(this.broadcast().buttonUrl, '_blank', 'noopener');
        this.closed.emit();
    }
}
